<template>
  <label
    class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
    :for="htmlId"
  >RENKO BOX-SIZE</label>
  <br />
  <input
    type="text"
    placeholder="Number"
    :id="htmlId"
    class="sc3-text-input sc3-text-input-inline sc3-text-input-slim sc3-text-input-compact sc3-text-input-grey-and-black"
    :class="{
      'one-hundred-pixels-min-width': isAtLeastOneHundredPixelsWide
    }"
    v-model="renkoBoxSize"
    ref="renkoBoxSizeInputElement"
    @blur="syncChartStoreRenkoBoxSize()"
    @keyup.enter="handleEnterKeyUpRenkoBoxSize()"
    autocomplete="off"
  />
</template>

<script lang="ts" setup>
  import { ref, watch, toRefs } from 'vue';
  import { storeToRefs } from 'pinia';
  import { useChartStore } from '@/stores/chartStore';

  const chartStore = useChartStore();
  const { renkoBoxSize: chartStoreRenkoBoxSize } = storeToRefs(chartStore);
  const props = defineProps<{
    htmlId: string;
    isAtLeastOneHundredPixelsWide: boolean;
  }>();
  const { htmlId, isAtLeastOneHundredPixelsWide } = toRefs(props);

  const renkoBoxSize = ref(chartStoreRenkoBoxSize.value.trim());
  const renkoBoxSizeInputElement = ref<HTMLInputElement>();

  function syncChartStoreRenkoBoxSize() {
    chartStore.$patch({ renkoBoxSize: renkoBoxSize.value.trim() });
  }

  function handleEnterKeyUpRenkoBoxSize() {
    renkoBoxSizeInputElement.value?.blur();
  }

  function handleChartStoreRenkoBoxSizeChanged() {
    renkoBoxSize.value = chartStoreRenkoBoxSize.value.trim();
  }

  watch(chartStoreRenkoBoxSize, handleChartStoreRenkoBoxSizeChanged);
</script>

<style scoped>
  .one-hundred-pixels-min-width {
    min-width: 100px;
  }
</style>
